namespace GeniuzPOS.Lookups {
    export interface LookupTxtColorRow {
        Id?: number;
        TxtColor?: string;
        TxtColorName?: string;
    }

    export namespace LookupTxtColorRow {
        export const idProperty = 'TxtColor';
        export const nameProperty = 'TxtColorName';
        export const localTextPrefix = 'Lookups.LookupTxtColor';
        export const lookupKey = 'Lookups.LookupTxtColor';

        export function getLookup(): Q.Lookup<LookupTxtColorRow> {
            return Q.getLookup<LookupTxtColorRow>('Lookups.LookupTxtColor');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            TxtColor = "TxtColor",
            TxtColorName = "TxtColorName"
        }
    }
}
